export default function Chevron(props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			width="16"
			height="14"
			viewBox="0 0 16 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M5.5866 12.8337L4.50977 11.7982L9.4996 7.00033L4.50977 2.20241L5.5866 1.16699L11.6533 7.00033L5.5866 12.8337Z"
				fill="currentColor"
			/>
		</svg>
	)
}
